import { h2, h3, h5, h5Css, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div<{ backgroundColor: string }>`
  background-color: ${(props) => props.backgroundColor};
  padding: 70px 70px;
  min-height: 735px;
  margin-bottom: 70px;
  width: calc(100% + 140px);
  margin-left: -70px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(600px, 100%), 1fr));
  gap: 70px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 100vw;
    margin-left: -20px;
    padding: 100px 50px;
    gap: 20px;
  }
  @media ${({ theme }) => theme.breakpoints.xs} {
    padding: 50px 16px;
  }
`;

const SideContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;
`;

const InfoContainer = styled.div`
  &:nth-child(2),
  &:nth-child(3) {
    margin-top: 70px;
  }
`;

const Title = styled(h2)<{ color: string }>`
  color: ${(props) => props.color};
  text-transform: uppercase;
`;

const H3Title = styled(h3)`
  color: ${(props) => props.color};
  text-transform: uppercase;
`;

const H5Title = styled(h5)<{ color: string }>`
  color: ${(props) => props.color};
  text-transform: uppercase;
  margin-top: 50px;
  line-height: 30px;
`;

const ContactLink = styled.a<{ color: string }>`
  ${h5Css}
  text-transform: uppercase;
  color: ${(props) => props.color};
  text-decoration: none;
  display: block;

  &:first-of-type {
    margin: 50px 0 30px 0;
  }
`;

const Paragraph = styled(paragraph)`
  width: 85%;
  margin-top: 30px;
  color: #424242;
`;

const AccentTitle = styled.span`
  color: #a78f67;
`;

const Line = styled.div<{ color: string }>`
  border: 2px solid ${(props) => props.color};
  width: 200px;
  height: 0px;
  margin: 28px 0 4px 0;
`;

const FormContainer = styled.div`
  margin-top: 40px;
  height: 100%;
`;

const S = {
  Line,
  Container,
  SideContainer,
  InfoContainer,
  Title,
  H3Title,
  H5Title,
  ContactLink,
  Paragraph,
  AccentTitle,
  FormContainer,
};

export default S;
